function injectStyle (ssrContext) {
  require("!!../../../../node_modules/.pnpm/extract-text-webpack-plugin@2.1.2_webpack@2.7.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-bbe9a168\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/selector?type=styles&index=0!./TopNavbar.vue")
}
var normalizeComponent = require("!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/selector?type=script&index=0!./TopNavbar.vue"
import __vue_script__ from "!!babel-loader!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/selector?type=script&index=0!./TopNavbar.vue"
/* template */
import __vue_template__ from "!!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bbe9a168\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/.pnpm/vue-loader@13.7.3_@vue+compiler-sfc@3.5.38_babel-core@6.26.3_supports-color@5.5.0__css-_2032f58a3f37950ca5d333a581f11c52/node_modules/vue-loader/lib/selector?type=template&index=0!./TopNavbar.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/Layout/TopNavbar.vue
// module id = 2aTV
// module chunks = 6